"use client";

import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Anthony Ursino",
  trade: "Premium Detailing Studio",
  quote: "Tallon one day cold called me about building me a website for my business. Now im getting calls left and right with new clients! Easiest person to work with and so professional!",
  rating: 5
}, {
  author: "Zac Parsons",
  trade: "HSC Systems",
  quote: "Amazing website development by Tallon! My website was developed to suit the industry and overall turned out perfect. Highly recommend",
  rating: 5
}, {
  author: "Dylan Wilson",
  trade: "Pristine Coat Painting",
  quote: "Tallon built our website for Pristine Coat Painting and we couldn't be happier. The whole process was smooth and he handled everything. The site looks great and has already helped our business look more professional.",
  rating: 5
}];
const marqueeData = [...testimonials, ...testimonials];
export default function WhatOurClientsSay() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [isPaused, setIsPaused] = useState(false);
  return <section id="what-our-clients-say" ref={ref} className={cn("bg-background text-foreground py-20 relative overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(61,193,188,0.03),transparent_70%)] pointer-events-none" />
      
      <div className="container mx-auto px-4 mb-12 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 font-sans">
          What Our <span className="text-primary">Clients Say</span>
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
          Trusted by trades and small businesses across the Central Coast.
        </p>
      </div>

      {}
      <div className="relative w-full overflow-hidden py-4" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
        {}
        <div className="absolute left-0 top-0 bottom-0 w-12 md:w-32 z-20 bg-gradient-to-r from-background to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-12 md:w-32 z-20 bg-gradient-to-l from-background to-transparent pointer-events-none" />

        <div className={cn("flex gap-6 w-max", !isPaused && "animate-[marquee_40s_linear_infinite]")} style={{
        animationPlayState: isPaused ? "paused" : "running"
      }}>
          {marqueeData.map((item, i) => <div key={i} data-index={i} className="w-[300px] md:w-[400px] flex-shrink-0">
              <Card className="h-full border-border/50 shadow-sm hover:border-primary/30 transition-colors duration-300">
                <CardContent className="p-6 flex flex-col h-full justify-between gap-4">
                  <div>
                    <div className="flex gap-1 mb-3">
                      {[...Array(item.rating)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="size-4 fill-primary text-primary" />)}
                    </div>
                    <Quote className="size-8 text-muted-foreground/20 mb-2" />
                    <p className="text-muted-foreground italic leading-relaxed">
                      "{item.quote}"
                    </p>
                  </div>
                  
                  <div className="flex items-center gap-3 mt-2 pt-4 border-t border-white/5">
                    <div className="size-10 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold text-sm">
                      {item.author.charAt(0)}
                    </div>
                    <div>
                      <p className="font-semibold text-foreground text-sm">
                        {item.author}
                      </p>
                      <p className="text-xs text-primary font-medium">
                        {item.trade}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>

      <div className="container mx-auto px-4 mt-12 text-center relative z-10">
        <Button asChild size="lg" className="rounded-full px-8 text-base font-semibold shadow-[0_0_20px_rgba(61,193,188,0.3)]">
          <Link to="/ContactPage">
            Start Your Project
          </Link>
        </Button>
      </div>

      <style jsx>{`
        @keyframes marquee {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>;
}